module.exports = __webpack_public_path__ + "static/media/IMG_0992.ee390c1b.JPG";